import { Truck } from "lucide-react";
import { DEUTSCHE_POST_PATH, DHL_PATH, DPD_PATH, FEDEX_PATH, HERMES_PATH, UPS_PATH } from "./brand-paths";
import { cx } from "./ui";

/**
 * Markenzeichen je Versanddienstleister – Kennzeichnung, keine Nachbildung.
 * box = Ausschnitt des Pfads (x y b h), h = Darstellungshöhe in px: Schriftzüge wie DHL sind sehr breit und
 * würden im quadratischen 24er-Raster winzig, daher auf das Zeichen zugeschnitten.
 */
const MARKS: Record<string, { path: string; color: string; bg?: string; box: [number, number, number, number]; h: number }> = {
  DHL: { path: DHL_PATH, color: "#D40511", bg: "#FFCC00", box: [0, 10.3, 24, 3.4], h: 9 },
  "DHL Express": { path: DHL_PATH, color: "#D40511", bg: "#FFCC00", box: [0, 10.3, 24, 3.4], h: 9 },
  "Deutsche Post": { path: DEUTSCHE_POST_PATH, color: "#000000", bg: "#FFCC00", box: [0, 2.53, 24, 18.94], h: 13 },
  DPD: { path: DPD_PATH, color: "#DC0032", box: [1.7, 0, 20.6, 24], h: 15 },
  UPS: { path: UPS_PATH, color: "#150400", bg: "#FFB500", box: [1.88, 0, 20.24, 24], h: 15 },
  FedEx: { path: FEDEX_PATH, color: "#4D148C", box: [0, 8.74, 24, 6.52], h: 11 },
  Hermes: { path: HERMES_PATH, color: "#0091CD", box: [0, 4.52, 24, 14.97], h: 12 },
};

/** Logo des Dienstleisters (Name als Hinweis); unbekannte Dienstleister: LKW-Symbol mit Namen */
export function CarrierMark({ brand, className }: { brand: string; className?: string }) {
  const m = MARKS[brand];
  if (!m)
    return (
      <span className={cx("inline-flex items-center gap-1 font-medium", className)}>
        <Truck className="size-3.5 text-fg-subtle" />
        {brand}
      </span>
    );
  const [x, y, w, h] = m.box;
  return (
    <span className={cx("inline-flex items-center justify-center h-5 min-w-7 px-1.5 rounded", m.bg ? "" : "bg-white ring-1 ring-border", className)} style={m.bg ? { background: m.bg } : undefined} title={brand} role="img" aria-label={brand}>
      <svg viewBox={`${x} ${y} ${w} ${h}`} height={m.h} width={Math.round((m.h * w) / h)} fill={m.color} aria-hidden="true"><path d={m.path} /></svg>
    </span>
  );
}
